import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dinh-muc-co-dinh-vat-tu-step" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-end gap-2 mb-3 flex-wrap"
}

import { computed, ref } from "vue";
import AddVatTuItemV2 from "@/components/add-vat-tu-items-v2/AddVatTuItemV2.vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import { AddVatTuItemsFor } from "@/core/enums/addVatTuItemsFor.enum";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import type { IVatTuResponseBase } from "@/core/interfaces/ApiResponses";
import type { DinhMucCoDinhVatTuLineDraft } from "@/types/dinh-muc-co-dinh";
import DinhMucCoDinhVatTuLinesTable from "./DinhMucCoDinhVatTuLinesTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DinhMucCoDinhVatTuStep',
  props: {
    lines: {},
    readonly: { type: Boolean, default: false },
    addButtonTabindex: { default: 1 }
  },
  emits: ["remove-line", "patch-line", "add-existing"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { ButtonTypeColors, ButtonsType } = useButtonCustom();
const isAddExistingOpen = ref(false);

const selectedExistingForModal = computed(() =>
  props.lines.map((line) => ({
    id: line.id_vat_tu,
    id_vat_tu: line.id_vat_tu,
    ma_vat_tu: line.ma_vat_tu ?? "",
    ten_vat_tu: line.ten_vat_tu ?? "",
    don_vi_tinh: line.don_vi_tinh ?? "",
    so_luong: line.so_luong,
  }))
);

const onExistingAdded = (payload?: {
  selectingVatTuItems?: Array<IVatTuResponseBase & { so_luong?: number }>;
}) => {
  isAddExistingOpen.value = false;

  if (payload?.selectingVatTuItems?.length) {
    emit("add-existing", payload.selectingVatTuItems);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AddVatTuItemV2, {
      "is-modal-open": isAddExistingOpen.value,
      "show-search-dmvt": false,
      "show-close-button": false,
      "use-for": _unref(AddVatTuItemsFor).ADD_VAT_TU_DINH_MUC_CO_DINH,
      "vat-tu-selected": selectedExistingForModal.value,
      onAdded: onExistingAdded,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isAddExistingOpen.value = false))
    }, null, 8, ["is-modal-open", "use-for", "vat-tu-selected"]),
    (!_ctx.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ButtonCustom, {
            "button-type": _unref(ButtonsType).ADD,
            "color-type": _unref(ButtonTypeColors).PRIMARY,
            tabindex: _ctx.addButtonTabindex,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isAddExistingOpen.value = true))
          }, {
            "button-label": _withCtx(() => [
              _createTextVNode("Thêm vật tư")
            ]),
            _: 1
          }, 8, ["button-type", "color-type", "tabindex"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(DinhMucCoDinhVatTuLinesTable, {
      lines: _ctx.lines,
      readonly: _ctx.readonly,
      onRemoveLine: _cache[2] || (_cache[2] = (key) => _ctx.$emit('remove-line', key)),
      onPatchLine: _cache[3] || (_cache[3] = (key, patch) => _ctx.$emit('patch-line', key, patch))
    }, null, 8, ["lines", "readonly"])
  ]))
}
}

})